import parsePhoneNumber from 'libphonenumber-js/min'
import * as authApi from '@/api/authApi'

export function email (value) {
  // eslint-disable-next-line
  return /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i.test(value)
}

export function password (value) {
  // Min 5 chars
  // Special chars allowed, but not required
  // Nums not required
  // return /^[A-Za-zА-Яа-я\d$@$!%*#?&^]{5,}$/g.test(value)

  // return /\d{5,}/g.test(value)
  return value.length >= 5
}

export function phoneNumber (phoneNumber) {
  return parsePhoneNumber(phoneNumber ?? '')?.isValid() ?? false
}

export async function uniqueUsername (username) {
  if (!username) {
    return
  }

  const payload = await authApi.checkUsernameUnique({ username })

  return payload.data?.isUnique ?? true
}

export function authCode (code) {
  return code.length === 0 || code.length === 4
}

export function telegramUsername (username) {
  const isValidPhoneNumber = phoneNumber(username)
  if (isValidPhoneNumber) {
    return true
  }

  if (username.startsWith('@')) {
    return true
  }

  const regex = /^[a-zA-Z0-9_]{5,32}$/g

  try {
    const url = new URL(username)
    const usernameFromPath = url.pathname.substring(1)

    return url.hostname === 't.me' && regex.test(usernameFromPath)
  } catch (e) {
    return regex.test(username)
  }
}

export function ymCounter (counter) {
  if (!counter) {
    return true
  }
  return /^-?\d{8}$/.test(counter)
}

export function gaCounter (counter) {
  if (!counter) {
    return true
  }
  const isGaV3 = /[A-Z]+-\d+-\d+/.test(counter) || /^\d+$/.test(counter) || /^(G|UA|YT|MO)-[a-zA-Z0-9-]+$/.test(counter) || /^(G|UA|YT|MO)-[a-zA-Z0-9-]+$/.test(counter)
  const isGaV4 = /G-\d+/g.test(counter)

  return isGaV3 || isGaV4
}
